
import {Component, Vue} from "vue-property-decorator";
import OrderPane from "../components/order-pane.vue";
import DatePicker from "@/components/date-picker.vue";
import {
  apiShopWithdrawLists,
  apiShopWithdrawApprove,
  apiShopWithdrawReject,
  apiShopWithdrawConfirmPay
} from "@/api/order";
import ExportData from "@/components/export-data/index.vue";
import {RequestPaging} from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import lsPagination from "@/components/ls-pagination.vue";

@Component({
  components: {
    lsPagination,
    LsDialog,
    OrderPane,
    DatePicker,
    ExportData,
  },
})
export default class Order extends Vue {
  // S Data

  apiShopWithdrawLists = apiShopWithdrawLists;

  index = 0;

  pager = new RequestPaging();

  form: any = {
    bank_name: "",
    shop_name: "",
    status: "",
  };

  rejectDialogVisible = false;
  rejectRemark = '';
  currentRejectId = 0;

  // E Data

  // S Methods

  getOrderLists() {
    this.pager
        .request({
          callback: apiShopWithdrawLists,
          params: {
            ...this.form,
          },
        })
  }

  reset() {
    Object.keys(this.form).map((key) => {
      this.$set(this.form, key, "");
    });
    this.getOrderLists();
  }

  // 审核通过
  handleApprove(row: any) {
    this.$confirm('确认审核通过该提现申请？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiShopWithdrawApprove({id: row.id}).then(() => {
        this.$message.success('审核通过');
        this.getOrderLists();
      });
    }).catch(() => {});
  }

  // 拒绝
  handleReject(row: any) {
    this.currentRejectId = row.id;
    this.rejectRemark = '';
    this.rejectDialogVisible = true;
  }

  doReject() {
    if (!this.rejectRemark) {
      this.$message.error('请填写拒绝原因');
      return;
    }
    apiShopWithdrawReject({id: this.currentRejectId, remark: this.rejectRemark}).then(() => {
      this.$message.success('已拒绝，提现金额已退回商户余额');
      this.rejectDialogVisible = false;
      this.getOrderLists();
    });
  }

  // 确认打款
  handleConfirmPay(row: any) {
    this.$confirm('确认调用建设银行API对公打款？打款成功后将自动标记为已打款。', '确认建行打款', {
      confirmButtonText: '确认打款',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const loading = this.$loading({ lock: true, text: '正在调用建行API打款，请稍候...', spinner: 'el-icon-loading' });
      apiShopWithdrawConfirmPay({id: row.id}).then((res: any) => {
        loading.close();
        this.$message.success(res.msg || '建行对公打款成功');
        this.getOrderLists();
      }).catch(() => {
        loading.close();
      });
    }).catch(() => {});
  }

  // E Methods

  // S  life cycle

  created() {
    this.getOrderLists();
  }

  // E life cycle
}
